"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryRewardsList = void 0;
var TimeUtil_1 = require("../../utils/TimeUtil");
var DateTimeFormatter_1 = __importDefault(require("../../utils/DateTimeFormatter"));
var HistoryRewardsList = /** @class */ (function (_super) {
    __extends(HistoryRewardsList, _super);
    function HistoryRewardsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDateStartSorted = function () {
            var rewardsList = new HistoryRewardsList();
            if (_this.length > 0) {
                _this.sort(function (x, y) {
                    var dateCreatedX = !!x.date_created ? x.date_created : 0;
                    var dateCreatedY = !!y.date_created ? y.date_created : 0;
                    return dateCreatedX > dateCreatedY ? -1 : 1;
                }).forEach(function (x) {
                    var dateCreated = x.date_created;
                    if (x.date_created && !/^-{0,1}\d+$/.test(dateCreated)) {
                        dateCreated = TimeUtil_1.formatTimeStampToUnixMonthOrdinalDayYear(x.date_created);
                    }
                    x.dateCreated = DateTimeFormatter_1.default.getFormattedDateFromTimeStamp('historyDateFormat', dateCreated);
                    rewardsList.push(x);
                });
            }
            return rewardsList;
        };
        return _this;
    }
    return HistoryRewardsList;
}(Array));
exports.HistoryRewardsList = HistoryRewardsList;
//# sourceMappingURL=HistoryRewardsList.js.map